import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { LINK_TEXT_ACTION } from "../../constants";

import "./styles.scss";

const LinkText = ({
  labelText,
  linkText,
  action,
  onClick,
  mailTo,
  linkTextStyle = {},
  containerStyle = {},
  labelTextStyle = {},
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const routeName = location.pathname.split("/")[1];

  return (
    <div className="link-text-container" style={containerStyle}>
      {labelText ? (
        <span className="label-text" style={labelTextStyle}>
          {t(routeName ? `${routeName}.${labelText}` : `${labelText}`, {
            currentYear: new Date().getFullYear(),
          })}
        </span>
      ) : null}
      {action === LINK_TEXT_ACTION.NAVIGATE_TO && (
        <span className="link-text" onClick={onClick} style={linkTextStyle}>
          {t(routeName ? `${routeName}.${linkText}` : `${linkText}`)}
        </span>
      )}
      {action === LINK_TEXT_ACTION.MAIL_TO && (
        <a
          className="link-text"
          href={`mailto:${mailTo}`}
          style={linkTextStyle}
        >
          {t(routeName ? `${routeName}.${linkText}` : `${linkText}`)}
        </a>
      )}
    </div>
  );
};

export default LinkText;
